import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SliderCard from "../../components/SliderElements/SliderCard";
import { useProjectDataQuery } from '../../hooks/useQueryHooks';
import usePerformanceMonitoring from '../../hooks/usePerformanceMonitoring';
// Import Swiper modules
import SwiperCore, { EffectFade, Pagination, Autoplay, Navigation } from "swiper";

// Initialize Swiper modules
SwiperCore.use([EffectFade, Pagination, Autoplay, Navigation]);

export const Sliders = () => {
    const { data: projectData, isLoading, error } = useProjectDataQuery();
    const performance = usePerformanceMonitoring('Sliders', [projectData]);
    
    // Track data loading time
    useEffect(() => {
        if (!isLoading && projectData) {
            performance.logPerformance(`Loaded ${projectData.length} projects, ${projectData.filter(data => data.isFeature === 'yes').length} featured`);
        }
    }, [isLoading, projectData, performance]);

    if (isLoading) {
        return (
            <div className="theme_slider bg-black">
                <div className="container" style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    marginTop: '40px', 
                    marginBottom: '3rem', 
                    position: 'relative', 
                    zIndex: '10',
                    textAlign: 'center',
                    width: '100%'
                }}>
                    <h2 className="section-header mb-5">Featured Projects</h2>
                    <div className="loading-container">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading featured projects...</p>
                    </div>
                </div>
            </div>
        );
    }
    
    if (error) {
        return (
            <div className="theme_slider bg-black">
                <div className="container" style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    marginTop: '40px', 
                    marginBottom: '3rem', 
                    position: 'relative', 
                    zIndex: '10',
                    textAlign: 'center',
                    width: '100%'
                }}>
                    <h2 className="section-header mb-5">Featured Projects</h2>
                    <div className="error-container">
                        <h3>Error Loading Projects</h3>
                        <p>{error.message || "Please try again later"}</p>
                    </div>
                </div>
            </div>
        );
    }
    
    if (!projectData || projectData.length === 0) {
        return (
            <div className="theme_slider bg-black">
                <div className="container" style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    marginTop: '40px', 
                    marginBottom: '3rem', 
                    position: 'relative', 
                    zIndex: '10',
                    textAlign: 'center',
                    width: '100%'
                }}>
                    <h2 className="section-header mb-5">Featured Projects</h2>
                    <div className="empty-container">
                        <h3>No Projects Available</h3>
                        <p>Check back soon for our featured projects</p>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="theme_slider bg-black">
            <div className="container" style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center',
                marginTop: '40px', 
                marginBottom: '3rem', 
                position: 'relative', 
                zIndex: '10',
                textAlign: 'center',
                width: '100%'
            }}>
                <h2 className="section-header mb-5">Featured Projects</h2>
                <div className="swiper swiper_theme_slider" data-swiper-autoplay="2000">
                    <Swiper
                        effect="slide"
                        slidesPerView={1}
                        loop={true}
                        spaceBetween={0}
                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                        }}
                        navigation={{
                            nextEl: '.swiper-button-next-features',
                            prevEl: '.swiper-button-prev-features',
                        }}
                        autoplay={{
                            delay: 5000,
                            disableOnInteraction: false,
                        }}>
                        {projectData.filter(data => data.isFeature === 'yes')
                            .map((data) => (
                            <SwiperSlide key={data.id}>
                                <SliderCard data={data}/>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    
                    {/* Custom Navigation Arrows */}
                    <div className="swiper-button-prev-features swiper-nav-arrow">
                        <i className="bi bi-chevron-left"></i>
                    </div>
                    <div className="swiper-button-next-features swiper-nav-arrow">
                        <i className="bi bi-chevron-right"></i>
                    </div>
                </div>
            </div>
        </div>
    );

}
